<template>
    <div class="w-full">
        <Button label="Добавить" @click='displayDialog=true' icon="pi pi-plus" iconPos="right" size="small"/>
    </div>

    <Dialog header="Добавить мерчанта" class="flex flex-column" modal
        v-model:visible="displayDialog" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '30vw'}" >

        <!--ID-->
        <div class="flex flex-column w-full mb-3">
            <span class="flex mb-2">ID пользователя: </span>
            <InputText v-model="userId" class="flex" />
        </div>

        <div class="w-full mb-3">
            <Button label="Добавить" @click='add()' :loading="loading"/>
        </div>

    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    name: 'AddMerchant',
    data() {
        return {
            loading: false,
            displayDialog: false,
            userId: null,
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        async add() {
            this.loading = true
            const add = await this.connect.AddMerchantByAdmin({user_id: this.userId}).then(res=>res).catch(err=>err)
            if(add.result &&  add.data){
                this.showMess('success', 'Успешно', 'Мерчант добавлен')
                this.displayDialog = false
            } else {
                if(add.errors && add.errors.length > 0){
                    this.showMess('error', 'Ошибка', add.errors[0])
                } else this.showMess('error', 'Ошибка', 'Ошибка добавления мерчанта')
            }
            this.loading = false
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>